<template>
  <section
    id="profileRiskAnalyses"
    v-if="employeeTagRiskAnalyses && employeeTagRiskAnalyses.length"
  >
    <v-row align="center" class="mt-3" style="max-height: 56px">
      <v-col cols="auto">
        <span class="title text--secondary text-uppercase">{{
          $t("profile.subheader.riskAnalyses")
        }}</span>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="employeeTagRiskAnalyses"
      class="safety-elevation-3 table-striped"
      hide-default-footer
      :items-per-page="-1"
      fixed-header
    >
      <template v-slot:[`item.parent.name`]="{ item }">
        {{
          item.riskAnalysis.tag.parent.description ||
            item.riskAnalysis.tag.parent.name
        }}
      </template>

      <template
        v-if="me && employee.id === me.id"
        v-slot:[`item.name`]="{ item }"
      >
        {{ item.riskAnalysis.tag.description || item.riskAnalysis.tag.name }}
      </template>

      <template v-else v-slot:[`item.name`]="{ item }">
        <a @click="toV3(`/risk-analysis/edit/${item.riskAnalysis.id}`)">
          {{ item.riskAnalysis.tag.description || item.riskAnalysis.tag.name }}
        </a>
      </template>

      <template v-slot:[`item.signatureDate`]="{ item }">
        <span v-if="item.signature">{{ item.signature.date | date }}</span>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          v-if="isSignable(item)"
          small
          color="deep-orange lighten-4"
          class="error--text text--darken-1 text-uppercase mr-1"
        >
          {{ $t("riskAnalysis.status.unsigned") }}
        </v-chip>
        <v-chip
          v-else-if="item.signature"
          small
          color="green lighten-4"
          class="success--text text--darken-1 text-uppercase mr-2"
        >
          ✔
        </v-chip>
        <v-chip
          v-else
          small
          color="orange lighten-4"
          class="warning--text text--darken-1 text-uppercase mr-1"
        >
          {{ $t("riskAnalysis.status.beingRevised") }}
        </v-chip>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          v-if="me && me.id == employee.id"
          :color="isSignable(item) ? 'primary' : undefined"
          :text="!isSignable(item)"
          small
          @click="navigateToRiskAnalysis(item.riskAnalysis.id, item.signature)"
        >
          {{ $t("instructions.read") }}
        </v-btn>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { mapState } from "vuex";

import EmployeeTagRiskAnalysesQuery from "@/graphql/queries/riskAnalysis/EmployeeTagRiskAnalyses.gql";

export default {
  props: ["employee"],
  watch: {
    "employee.tags": {
      handler() {
        this.$apollo.queries.employeeTagRiskAnalyses.refresh();
      },
    },
    employeeTagRiskAnalyses(newVal) {
      this.$emit("risk-analyses", newVal);
    },
  },
  computed: {
    ...mapState(["me", "appSettings"]),
    headers() {
      let h = [
        {
          text: this.$i18n.t("riskAnalysis.column.department"),
          value: "parent.name",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("riskAnalysis.column.workArea"),
          value: "name",
          class: "text-uppercase subheading text-truncate",
        },
      ];

      if (this.appSettings.isRiskAnalysisSigningEnabled) {
        h.push(
          {
            text: this.$i18n.t("instructions.column.signatureDate"),
            value: "signatureDate",
            class: "text-uppercase subheading text-truncate",
          },
          {
            text: this.$i18n.t("instructions.column.status"),
            value: "status",
            class: "text-uppercase subheading text-truncate",
          }
        );
      }

      if (this.me && this.me.id == this.employee.id) {
        h.push({
          text: this.$i18n.t("riskAnalysis.column.action"),
          value: "action",
          align: "right",
          class: "text-uppercase subheading text-truncate",
        });
      }

      return h;
    },
  },
  methods: {
    navigateToRiskAnalysis(riskAnalysisId, isSigned) {
      const signedParameter =
        this.appSettings.isRiskAnalysisSigningEnabled && isSigned
          ? "?signed=true"
          : "";
      window.location.replace(
        "/v3/risk-analysis/" + riskAnalysisId + signedParameter
      );
    },
    toV3(path) {
      window.open("/v3" + path, "_blank");
    },
    isSignable(item) {
      return (
        this.appSettings.isRiskAnalysisSigningEnabled &&
        item.riskAnalysis.status === "confirmed" &&
        !item.signature
      );
    },
  },
  apollo: {
    employeeTagRiskAnalyses: {
      query: EmployeeTagRiskAnalysesQuery,
      variables() {
        return {
          employeeId: this.employee.id,
        };
      },
      skip() {
        return !this.employee || !this.employee.id;
      },
    },
  },
};
</script>
